import { AccountPanelTypes } from '../AccountPanelTypes';
import { PayRentTypes } from '../PayRentTypes';
import { navigate } from 'gatsby';

export const getNextBillingDate = (date: string | undefined) => {
  if (date) {
    const nextBillingDate = new Date(date);
    const day = nextBillingDate.getDate();
    const month = nextBillingDate.getMonth() + 1;
    const year = nextBillingDate.getFullYear();
    return `${month <= 9 ? '0' + month : month}-${
      day <= 9 ? '0' + day : day
    }-${year}`;
  } else {
    return undefined;
  }
};

export const getSmallestDate: AccountPanelTypes.TSmallDateFunction = unitResponse => {
  const todaysDate = new Date().toISOString().split('T')[0];
  const rentAssessmentDateArray = unitResponse
    .filter(
      (indivUnitData: any) =>
        indivUnitData.rental_status &&
        indivUnitData.rental_status === 'Rented' &&
        indivUnitData.next_rent_assessment_date >= todaysDate
    )
    .map((unitsArray: any) => unitsArray.next_rent_assessment_date);
  const isPendingUnitPresent = unitResponse.some(
    (indivUnitData: any) => indivUnitData.rental_status === 'Esign_Pending'
  );
  if (rentAssessmentDateArray.length > 0 && !isPendingUnitPresent) {
    return rentAssessmentDateArray.reduce(reducer);
  } else {
    return undefined;
  }
};

const reducer = (p: string, c: string) => {
  if (p > c) {
    return c;
  } else {
    return p;
  }
};

export const getPaymentMethodId: PayRentTypes.TPaymentMethodIdFunction = (
  paymentMethodResponse,
  detectedCardType
) => {
  let paymentMethodId = '';
  for (const indivPaymentMethod of paymentMethodResponse) {
    const { value, child_configuration, id } = indivPaymentMethod;

    if (
      value?.type === 'Credit_Card' &&
      value?.description?.toUpperCase() === detectedCardType.toUpperCase()
    ) {
      paymentMethodId = child_configuration?.[0]?.id || id;
      return paymentMethodId;
    }
  }
  return paymentMethodId;
};

export const getDecimalBalance = (balance: any) => {
  const numBalance = Number(balance);
  let returnNumber = '';
  const stringBalance = String(Math.abs(balance)).split('.');
  if (stringBalance.length === 1 || stringBalance[1].length < 3) {
    returnNumber = numBalance.toFixed(2);
  }
  return returnNumber;
};

export const logOut = () => {
  let allCookies = document.cookie.split(';');
  for (let i = 0; i < allCookies.length; i++) {
    document.cookie =
      allCookies[i] + '=;expires=' + new Date(0).toUTCString() + '=;path=/';
  }
  navigate('/', { replace: true });
};

export function cc_brand_id(cur_val: any) {
  const jcb_regex = new RegExp('^(?:2131|1800|35)[0-9]{0,}$');
  const amex_regex = new RegExp('^3[47][0-9]{0,}$');
  const diners_regex = new RegExp('^3(?:0[0-59]{1}|[689])[0-9]{0,}$');
  // Visa
  const visa_regex = new RegExp('^4[0-9]{0,}$');

  const mastercard_regex = new RegExp(
    '^(5[1-5]|222[1-9]|22[3-9]|2[3-6]|27[01]|2720)[0-9]{0,}$'
  );
  const maestro_regex = new RegExp('^(5[06789]|6)[0-9]{0,}$');
  const discover_regex = new RegExp(
    '^(6011|65|64[4-9]|62212[6-9]|6221[3-9]|622[2-8]|6229[01]|62292[0-5])[0-9]{0,}$'
  );
  cur_val = cur_val.replace(/\D/g, '');
  let sel_brand = 'unknown';
  if (cur_val.match(jcb_regex)) {
    sel_brand = 'jcb';
  } else if (cur_val.match(amex_regex)) {
    sel_brand = 'amex';
  } else if (cur_val.match(diners_regex)) {
    sel_brand = 'diners_club';
  } else if (cur_val.match(visa_regex)) {
    sel_brand = 'visa';
  } else if (cur_val.match(mastercard_regex)) {
    sel_brand = 'master card';
  } else if (cur_val.match(discover_regex)) {
    sel_brand = 'discover';
  } else if (cur_val.match(maestro_regex)) {
    if (cur_val[0] == '5') {
      sel_brand = 'master card';
    } else {
      sel_brand = 'maestro';
    }
  }
  return sel_brand;
}
